<template>
  <div id="memberList">
    <div class="memberTop">广场成员（{{tableData.length}}）</div>
    <van-loading type="spinner" class="van_loading" v-if="isLoading" />
    <ul class="memberItems" v-if="!isLoading && tableData.length != 0">
      <li
        class="memberItem"
        v-for="(v,i) in tableData"
        :key="i"
        v-show="v.chat_admin == 1"
        @click="selectFun(v.user_id,v.nick_name)"
        @mousedown.prevent="getBannedOut($event,v.user_id,v.nick_name)"
        @contextmenu.prevent
      >
        <img src="./img/me_img_default@2x.1.png" v-if="!v.image_path" />
        <img :src="v.image_path" v-else @error="getError" />
        <div class="admin">管理员</div>
        <div class="nickName">{{v.nick_name}}</div>
        <!-- <div class="rightClick1" v-if="rightId == v.user_id">
            <ul >
                          <li @click="confige(i+1)" v-for="(v,i) in  itemList" :key="i"> 
                            <span  v-if="i<=2">禁言</span>
                            <span  v-else>踢出</span>
                            <span  v-if="v.value === '永久'">{{v.value}}</span>
                            <span  v-else>{{v.value}}小时</span>
                          </li>
                        </ul>
        </div>-->
      </li>
      <li
        class="memberItem"
        v-for="v in tableData"
        :key="v.id"
        v-show="v.chat_admin != 1"
        @click="selectFun(v.user_id,v.nick_name)"
        @mousedown.prevent="getBannedOut($event,v.user_id,v.nick_name)"
        @contextmenu.prevent
      >
        <img src="./img/me_img_default@2x.1.png" v-if="!v.image_path" />
        <img :src="v.image_path" v-else @error="getError" />
        <div class="level">Lv.{{v. login_level}}</div>
        <div class="nickName">{{v.nick_name}}</div>
        <div class="rightClick1" v-if="rightId == v.user_id">
          <ul>
            <li @click="confige($event,i+1,v.value)" v-for="(v,i) in  itemList" :key="i">
              <span v-if="i<=2">禁言</span>
              <span v-else>踢出</span>
              <span v-if="v.value === '永久'">{{v.value}}</span>
              <span v-else>{{v.value}}小时</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="noData" v-if="!isLoading && tableData.length == 0">暂无数据</div>
  </div>
</template>
<script>
import bus from "@/tool/bus";
export default {
  data() {
    return {
      isLoading: true,
      tableData: [],
      timer: "",
      beAtUserId: "",
      rightclickShow: false,
      rightId: "",
      itemList: [],
      UserId: "",
      Administrators: window.localStorage.getItem("Admin"), //是否是管理员  1是管理员 0不是
      myid: window.localStorage.getItem("uid") //自己的id、
    };
  },
  mounted() {
    this.getChatUserList();
    this.timer = setInterval(() => {
      this.getChatUserList();
    }, 30000);
  },
  methods: {
    // 图片错误
    getError() {
      var img = event.srcElement;
      img.src = require("./img/me_img_default@2x.1.png"); //替换的图片
      img.onerror = null; //控制不要一直触发错误
    },
    getChatUserList() {
      this.axios({
        method: "post",
        url: this.chatUrl + "api/user/getChatUserList",
        data: {
          token: window.localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 0) {
          this.isLoading = false;
          this.tableData = res.data.data;
          //console.log(this.tableData)
        } else {
          this.isLoading = false;
        }
      });
    },
    //点击头像艾特
    selectFun(val, name) {
      bus.$emit("AtThisUser", val, name);
    },
    // 右键点击成员
    getBannedOut(e, useid, name) {
      if (this.myid == useid) {
        return;
      }
      if (this.Administrators != 0) {
        e.stopPropagation();
        if (e.which === 3) {
          this.rightId = useid;
          this.UserId = useid;
          let that = this;
          document.body.onclick = function() {
            that.rightId = "";
          };
          this.axios({
            method: "post",
            url: this.chatUrl + "api/user/getBannedOut",
            data: {
              token: window.localStorage.getItem("token")
            }
          }).then(res => {
            if (res.data.code == 0) {
              this.itemList = res.data.data;
            } else {
              //this.isLoading = false;
            }
          });
        }
      }
    },
    confige(e, i, val) {
      bus.$emit("confige", i, val, this.UserId);
      e.stopPropagation();
      this.rightId = "";
      this.UserId = "";
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style scoped>
.rightClick {
  width: 11.25rem /* 180/16 */;
  height: 14.375rem /* 230/16 */;
  background-color: #fff;
  position: absolute;
  top: 6.25rem /* 100/16 */;
  left: 3.75rem /* 60/16 */;
}
.rightClick ul li {
  width: 100%;
  line-height: 1.8;
  padding-left: 1.25rem /* 20/16 */;
  cursor: pointer;
  box-sizing: border-box;
}
.rightClick1 {
  width: 12.5rem /* 200/16 */;
  background-color: #f2f2f2;
  position: absolute;
  top: 1.25rem /* 20/16 */;
  left: 1.25rem /* 20/16 */;
  z-index: 99;
}
.rightClick1 ul {
  padding: 0.625rem /* 10/16 */;
}
.rightClick1 ul li {
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 1.8;
  padding: 0 1.25rem /* 20/16 */;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 0.875rem /* 14/16 */;
  border-bottom: 1px solid #ccc;
}
#memberList {
  height: 100%;
  text-align: left;
  overflow: auto;
  position: relative;
  overflow: auto;
}
.memberTop {
  height: 1.75rem;
  color: #282828;
  font-size: 0.875rem;
  background-color: #f4f4f4;
  line-height: 1.75rem;
  padding-left: 0.8125rem;
  border: 1px solid #eeecec;
}
.van_loading {
  position: absolute;
  left: calc((100% - 2.5625rem) / 2);
  top: calc((100% - 2.5625rem) / 2);
}
.noData {
  height: calc(100% - 2.2rem);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b6b6b6;
}
.memberItems {
  height: calc(100% - 2.1rem);
  overflow-y: auto;
  cursor: pointer;
}
.memberItem {
  display: flex;
  align-items: center;
  margin-top: 0.625rem;
  position: relative;
}
.memberItem img {
  width: 1.5rem /* 24/16 */;
  height: 1.5rem;
  border-radius: 50%;
  margin-left: 0.975rem;
}
.memberItem .admin {
  border: 1px solid #fff1df;
  background: linear-gradient(
    90deg,
    rgba(252, 147, 20, 1),
    rgba(255, 207, 53, 1)
  );
  border-radius: 0.125rem /* 2/16 */;
  font-size: 0.75rem;
  width: 4em;
  height: 1.5em;
  line-height: 1.5em;
  text-align: center;
  color: #fff;
  margin: 0 0.5rem;
}
.memberItem .level {
  background: rgba(255, 241, 223, 1);
  border: 0.0625rem solid rgba(255, 163, 60, 1);
  border-radius: 0.125rem /* 2/16 */;
  font-size: 0.75rem;
  height: 1.5em;
  line-height: 1.5em;
  padding: 0 0.5rem;
  text-align: center;
  color: #ffa33c;
  margin: 0 0.5rem;
}
.memberItem .nickName {
  font-size: 0.75rem;
}
</style>


// WEBPACK FOOTER //
// src/components/chatPlaza/memberList.vue